import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import isEqual from "react-fast-compare";
import { PrivateGalleryBoardAncestors } from "~/components/PrivateGallery/PrivateGalleryBoardAncestors";
import { useGetPrivateBoardMenuOptionsCallback } from "~/components/PrivateGallery/useGetPrivateBoardMenuOptionsCallback";
import { useIsSearchActive } from "~/hooks/search/useIsSearchActive";
import { useBoardPermissions } from "~/hooks/useBoardPermissions";
import { useGoToBoardPage } from "~/hooks/useGoToBoardPage";
import { useOpenBoardInNewTab } from "~/hooks/useOpenBoardInNewTab";
import { usePrivateSelectionMenuOptions } from "~/hooks/usePrivateSelectionMenuOptions";
import { canChangeBoardCustomFields, canSeeBoardCustomFields } from "~/utils/permissions/boardPermissions";
import { isMobileAgent } from "~/utils/PlatformHelpers";
import { KanbanBoardComponent } from "./shared/KanbanBoardComponent";
export const PrivateKanbanBoard = /*#__PURE__*/ memo((param)=>{
    let { board, kanbanDndItemData, style } = param;
    var _board_library;
    const { boardPermissions } = useBoardPermissions({
        boardId: board.id
    });
    const { isSearchActive } = useIsSearchActive();
    const { getSelectionMenuOptions } = usePrivateSelectionMenuOptions();
    const { getBoardMenuOptionsCallback } = useGetPrivateBoardMenuOptionsCallback();
    const _getItemMenuOptions = getBoardMenuOptionsCallback({
        item: board
    });
    const { goToBoardPage } = useGoToBoardPage();
    const { openBoardInNewTab } = useOpenBoardInNewTab();
    const onBoardClick = useCallback(()=>goToBoardPage({
            board,
            trackLocation: "gallery-item"
        }), [
        board,
        goToBoardPage
    ]);
    const onBoardCmdClick = useCallback(()=>openBoardInNewTab({
            board,
            trackLocation: "gallery-item"
        }), [
        board,
        openBoardInNewTab
    ]);
    const canViewCustomFields = canSeeBoardCustomFields(boardPermissions);
    const canChangeCustomFields = canChangeBoardCustomFields(boardPermissions);
    return /*#__PURE__*/ _jsx(KanbanBoardComponent, {
        board: board,
        getItemMenuOptions: _getItemMenuOptions,
        getSelectionMenuOptions: getSelectionMenuOptions,
        kanbanDndItemData: kanbanDndItemData,
        onClick: onBoardClick,
        onCmdClickTitle: onBoardCmdClick,
        isSelectable: false,
        ancestors: isSearchActive ? /*#__PURE__*/ _jsx(PrivateGalleryBoardAncestors, {
            libraryTitle: (_board_library = board.library) === null || _board_library === void 0 ? void 0 : _board_library.title,
            ancestors: board.ancestors
        }) : undefined,
        style: style,
        dndDisabled: isMobileAgent || !canChangeCustomFields,
        canViewCustomFields: canViewCustomFields
    });
}, isEqual);
PrivateKanbanBoard.displayName = "PrivateKanbanBoard";
